module.exports = __webpack_public_path__ + "media/banners/finansowanie-menu-8c3b84a1.svg";